<template>
    <v-list-item link height="62" @click="logout">
        <v-list-item-icon><v-icon large color="#5b8ff5">mdi-logout</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import {logout as logOut} from '@/services/logout.js'

export default {
    data() {
        return {}
    },
    methods: {
        logout(e) {
            e.preventDefault()
            logOut()
        }
    }
}
</script>